<div class="card p-4 border-0">
    <h1 class="blue-0041A3 font-size-24 font-solomon-bold mb-1"><i class="icon-house mr-2"></i>{{ 'Inicio' | translate }}</h1>
    <p>{{ '¡Bienvenido! Esta es tu plataforma de reportería y administración de tu negocio.' | translate }}</p>
    <div class="text-center" *ngIf="link_bi_marketing!=null">
        <h2 class="blue-0041A3 font-solomon-black font-size-18 my-4">
            {{ 'Servicio de Mercadeo' | translate }}
            <i class="icon-settings float-right gray-C4C7CE cursor"></i>
        </h2>
        <iframe  width="100%" height="800" [src]="getBIMarketing()" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="text-center" *ngIf="link_bi_sales!=null">
        <h2 class="blue-0041A3 font-solomon-black font-size-18 my-4">
            {{ 'Servicio de Ventas' | translate }}
            <i class="icon-settings float-right gray-C4C7CE cursor"></i>
        </h2>
        <iframe  width="100%" height="800" [src]="getBISales()" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="text-center" *ngIf="link_bi_marketing==null && link_bi_sales==null">
        <img src="/assets/img/imagen-BI.png" class="img-fluid mt-3">
    </div>
    

</div>


